module.exports = __webpack_public_path__ + "img/ebay.06bb018d.png";